import TOP from './TOP.base64'
import BOTTOM from './BOTTOM.base64'

export default {
  TOP,
  BOTTOM
}